import { render, staticRenderFns } from "./ApprovedScientificTopicsFilterComponent.vue?vue&type=template&id=4c6dd770&"
import script from "./ApprovedScientificTopicsFilterComponent.vue?vue&type=script&lang=js&"
export * from "./ApprovedScientificTopicsFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports